import { axiosMock } from '@api/client';
import { API_URL } from '@api/apiDictionary';
import { faker } from '@faker-js/faker';
import { ImagingLabel } from '@dynamika-shared/types/imagingLabels';

export const generateImagingLabels = (): ImagingLabel => ({
  id: faker.string.uuid(),
  name: faker.lorem.words(2),
  code: faker.lorem.word(),
  system: faker.lorem.word(),
  modalityId: faker.string.uuid(),
  bodyPartId: faker.string.uuid(),
});

export const createRandomImagingLabelsList = (count: number): ImagingLabel[] => {
  return faker.helpers.multiple(generateImagingLabels, { count });
};

export const fetchImagingLabelsMock = async () => {
  const data = createRandomImagingLabelsList(20);
  return axiosMock.onGet(API_URL.imagingLabels).reply(200, data);
};

